module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "toast",
    class: _vm.position
  }, [_c('i', [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11b3e062!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/toast.vue
// module id = 70
// module chunks = 2